"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _ADDON_BRAND_DOMAIN$A;

var includesMarketingPro = function includesMarketingPro(_ref) {
  var marketingPlanSelected = _ref.marketingPlanSelected;
  return marketingPlanSelected === _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL;
};

var includesMarketingEnt = function includesMarketingEnt(_ref2) {
  var marketingPlanSelected = _ref2.marketingPlanSelected;
  return marketingPlanSelected === _MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE;
};

var includesCmsEnt = function includesCmsEnt(_ref3) {
  var cmsPlanSelected = _ref3.cmsPlanSelected;
  return cmsPlanSelected === _MerchandiseIds.PRODUCT_CMS_ENTERPRISE;
};

var _default = (_ADDON_BRAND_DOMAIN$A = {}, (0, _defineProperty2.default)(_ADDON_BRAND_DOMAIN$A, _MerchandiseIds.ADDON_BRAND_DOMAIN, {
  isRestricted: function isRestricted(selections) {
    return !includesMarketingEnt(selections) && !includesCmsEnt(selections);
  },
  restrictionKey: 'includeMarketingEntOrCmsEnt'
}), (0, _defineProperty2.default)(_ADDON_BRAND_DOMAIN$A, _MerchandiseIds.ADDON_DEDICATED_IP, {
  isRestricted: function isRestricted(selections) {
    return !includesMarketingPro(selections) && !includesMarketingEnt(selections);
  },
  restrictionKey: 'includeMarketingProOrEnt'
}), (0, _defineProperty2.default)(_ADDON_BRAND_DOMAIN$A, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, {
  isRestricted: function isRestricted(selections) {
    return !includesMarketingPro(selections) && !includesMarketingEnt(selections);
  },
  restrictionKey: 'includeMarketingProOrEnt'
}), _ADDON_BRAND_DOMAIN$A);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/AddonBundleRestrictionsMap.js
// module id = 477
// module chunks = 5 6